/**
 * @function
 * @param {string} val - The value to check
 * @returns {boolean} - Returns true if the value can be parsed as a number, false otherwise
 * @example
 * isValidNumericString('12.34'); // true
 * isValidNumericString('abc'); // false
 */
export default function isValidNumericString(val) {
  return !isNaN(parseFloat(val));
}
